import { render, staticRenderFns } from "./MessagePopup.vue?vue&type=template&id=084a528e&scoped=true"
import script from "./MessagePopup.vue?vue&type=script&lang=js"
export * from "./MessagePopup.vue?vue&type=script&lang=js"
import style0 from "./MessagePopup.vue?vue&type=style&index=0&id=084a528e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a528e",
  null
  
)

export default component.exports